import React from 'react';
import TextField, { StandardTextFieldProps } from '@material-ui/core/TextField';
import {
    FieldPath,
    FieldValues,
    UseFormReturn,
} from 'react-hook-form';

export type InputProps<Form extends FieldValues = FieldValues> =
    StandardTextFieldProps & {
        name: FieldPath<Form>;
        label?: string;
        placeholder?: string;
        formRef: UseFormReturn<Form>;
    };

export const TextInput = <Form extends FieldValues>(Props: InputProps<Form>) => {
    const { formRef, ...inputProps } = Props;

    const { register, formState } = formRef;
    const { name } = inputProps;
    const registration = register(name);
    const error = formState.errors[name] as { message?: string } | undefined;
    const massage = error?.message || '';

    return (
        <TextField
            {...registration}
            className={formState.isValid ? 'success' : ''}
            helperText={massage}
            error={!!massage}
            disabled={formState.isSubmitting}
            fullWidth
            {...inputProps}
            name={name}
        />
    );
};
